export const submitForm = (method: string, actionUrl: string, target: string, params: Record<string, string>) => {
  const form = document.createElement('form');
  form.method = method;
  form.action = actionUrl;
  form.target = target;
  form.style.display = 'none';

  Object.entries(params).forEach(([name, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  form.remove();
};
